export const D7_ROUTE_HOME = '';
export const D7_LOGIN_ROUTE = '/account/login';
export const D7_PASSWORD_RECOVERY_ROUTE = '/account/verify-token-request';
export const D7_UNDER_MAINTANANCE = '/under-maintenance';
